import { PriceLevel, Promotion, TicketType } from "webshop-api";

export class PriceListUtil {

    /**
     * Returns primary price in provided price level / promotion (TicketType with lowest number)
     */
    public static getStartPriceFor(priceLevel: PriceLevel, promotion: Promotion | null): number {
        if (!priceLevel || !priceLevel.promotionHolds) { return 0; }
        const promotionId = promotion !== null ? promotion.id! : 0;
        const ticketTypes = this.getTicketTypesForPromotion(promotionId, priceLevel)
            .filter(type => type !== undefined);

        if (ticketTypes.length === 0) {
            return 0;
        }

        return ticketTypes.reduce((defaultType: TicketType, ticketType: TicketType) => {
            return !ticketType.number < !defaultType.number ? ticketType : defaultType;
        }).price!;
    }

    /**
     * Returns TicketTypes for provided promotion id and price level
     * @param id
     * @param priceLevel
     */
    public static getTicketTypesForPromotion(id: number, priceLevel: PriceLevel): TicketType[] {
        if (!priceLevel.promotionHolds) { return []; }
        const promotionHold = priceLevel.promotionHolds.find(item => item.id === id);

        if (!promotionHold || !promotionHold.holds || !promotionHold.holds.length) { return []; }
        const hold = promotionHold.holds.find(item => item.number === 0);

        return hold && hold.ticketTypes ? hold.ticketTypes : [];
    }

}
